export default {"src":"/_next/static/media/tooltip.396c7bfc.svg","height":30,"width":30};